import { action, makeObservable, observable, runInAction } from 'mobx';
import UserApi from '../rest-api/user-api';

class ImageLibraryStore {
    images = [];
    isLoading = false;
    isInitialized = false;
    idToken;

    constructor(idToken) {
        this.idToken = idToken;

        makeObservable(this, {
            images: observable,
            isLoading: observable,
            isInitialized: observable,
            fetchImageLibrary: action,
            setImages: action,
        });
    }

    setImages(images) {
        this.images = Array.isArray(images) ? images : [];
        this.isInitialized = true;
    }

    async fetchImageLibrary({ force = false } = {}) {
        if (this.isLoading || (this.isInitialized && !force)) return this.images;

        runInAction(() => {
            this.isLoading = true;
        });

        try {
            const result = await UserApi.getImageLibrary(this.idToken);
            runInAction(() => {
                this.setImages(result.images || []);
            });
            return this.images;
        } finally {
            runInAction(() => {
                this.isLoading = false;
            });
        }
    }

    async refreshImageLibrary() {
        return this.fetchImageLibrary({ force: true });
    }

    async deleteDatabase() {
        this.images = [];
        this.isInitialized = false;
    }
}

export default async function createImageLibraryStore(idToken) {
    return new ImageLibraryStore(idToken);
}
